import { render, staticRenderFns } from "./IdentityDetails.vue?vue&type=template&id=33a23429&"
import script from "./IdentityDetails.vue?vue&type=script&lang=js&"
export * from "./IdentityDetails.vue?vue&type=script&lang=js&"
import style0 from "./IdentityDetails.vue?vue&type=style&index=0&id=33a23429&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports